import { useContext, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import FrameDialog from "../ui/containers/FrameDialog";
import FrameHeader from "../ui/containers/FrameHeader";
import FrameDialogContent from "../ui/containers/FrameDialogContent";
import { closeTariffy } from "../store/utils-slice";
import { Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import UserCtx from "../store/UserCtx";
import { useSnackbar } from "notistack";

const eulaText = `
<p><strong>END USER LICENSE AGREEMENT (EULA)</strong></p>
<p><strong>IMPORTANT NOTICE &ndash; PLEASE READ CAREFULLY</strong></p>
<p>This End User License Agreement ("Agreement" or "EULA") is a legally binding agreement between <strong>PARA BELLUM GAMES LTD</strong>, a private limited liability company registered under the laws of Cyprus with registration number &Eta;&Epsilon;297366, ("Para Bellum," "we," "our," or "us"), and you, the individual consumer purchasing Para Bellum&rsquo;s products and accessing the Licensed Content and Services ("you" or the "User").</p>
<p><strong>IMPORTANT- READ THIS SECTION BEFORE YOU PROCEED.</strong></p>
<p>By purchasing and opening a Para Bellum product package, registering with a Unique Code, accessing our website, or downloading or using the Licensed Content, you acknowledge that you have read, understood, and agree to be bound by this Agreement.</p>
<p>If you do not agree to the terms of this Agreement, you must not access, install, or use the Licensed Content or Services.</p>
<p>By (i) clicking "Agree" where presented on our website, (ii) registering a Unique Code, or (iii) accessing or downloading the Licensed Content (the "Rules"), you confirm that</p>
&nbsp;&nbsp; (a) you are a consumer,<br/>
&nbsp;&nbsp; (b) you are at least the legal age of majority in your country of residence; or, if you are under the age of majority, that you have obtained the prior consent of your parent or legal guardian to purchase the Product, register a Unique Code, and use the Licensed Content.<br/>
<p>Parents and legal guardians are responsible for ensuring that minors under their supervision comply with this Agreement. If you are a parent or guardian and you permit a minor to access the Licensed Content, you accept responsibility for the minor&rsquo;s use of the Product, Licensed Content, and Services.</p>
<p>If you do not agree to all terms of this EULA, do not register a Unique Code and do not access or download the Rules. You may be eligible to return the Product in accordance with Para Bellum&rsquo;s applicable return policy and your statutory consumer rights.</p>
<p>Any use of the Licensed Content or Services other than as expressly permitted by this EULA may infringe Cyprus, EU, and international copyright laws and treaties.</p>

<p><strong>I. DEFINITIONS</strong></p>
For the purposes of this Agreement:<br/>
&nbsp;&nbsp;1.1 "Product" means any physical model, miniature, accessory, or related tangible item manufactured and/or sold by Para Bellum.<br/>
&nbsp;&nbsp;1.2 "Licensed Content" or "Rules" means Para Bellum&rsquo;s proprietary rulebooks, game rules, updates, expansions, errata, and related digital materials accessible through Para Bellum&rsquo;s website upon activation of a Unique Code.<br/>
&nbsp;&nbsp;1.3 "Unique Code" means the twelve (12) digit PIN code included in the Product packaging, which allows registration on Para Bellum&rsquo;s website for the purpose of accessing the Licensed Content and Services.<br/>
&nbsp;&nbsp;1.4 "Services" means ancillary digital and interactive services offered by Para Bellum, including downloadable updates, access to Para Bellum&rsquo;s online account features, and eligibility to participate in tournaments, championships, and reward programs.<br/>
&nbsp;&nbsp;1.5 "App" means Para Bellum&rsquo;s mobile application, available to the general public, subject to separate terms of use.<br/>
&nbsp;&nbsp;1.6 "License Fee" means the portion of the purchase price allocated to the Licensed Content and Services. For clarity, 80% of the purchase price corresponds to the License Fee, and 20% corresponds to the physical Product.<br/>
&nbsp;&nbsp;1.7 "Territory" means worldwide.<br/>

<p><strong>II. GRANT OF LICENSE</strong></p>
2. Subject to full compliance with this Agreement, Para Bellum grants you a personal, limited, non-exclusive, non-transferable, non-sublicensable, worldwide license to:<br/>
&nbsp;&nbsp;2.1. access, download, and use the Licensed Content solely for personal, non-commercial gameplay;<br/>
&nbsp;&nbsp;2.2. access and use the Services linked to your registered account; and<br/>
&nbsp;&nbsp;2.3. participate in Para Bellum-organised tournaments and reward programs.<br/>
&nbsp;&nbsp;2.4. The License becomes effective upon registration of a Unique Code and remains valid for twelve (12) months. It shall automatically renew for subsequent twelve (12) month periods provided you log in and download any updated Licensed Content at least once in the preceding term.<br/>
&nbsp;&nbsp;2.5. Reservation of Rights. Para Bellum retains all rights not expressly granted herein. This License does not convey to you any ownership interest in the Licensed Content, but only a limited right of use, revocable in accordance with the terms of this Agreement. The Licensed Content is not being sold to you. Para Bellum Games Ltd and its licensors retain all rights, title, and interest in and to the Licensed Content, the Rules, and related intellectual property. No license or other right in or to the Licensed Content is granted to you except for the rights expressly set forth in this Agreement. You agree to comply with all applicable laws and international treaties governing the use of the Licensed Content.<br/>
&nbsp;&nbsp;2.6. Right to Modify Agreement. Para Bellum reserves the right to modify, update, or adapt the terms of this Agreement at any time, for example to reflect changes in applicable law, improvements to the Licensed Content, or adjustments to commercial practices. Any modifications will be effective upon posting the revised Agreement on Para Bellum&rsquo;s website or app. Continued use of the Licensed Content or Services after such posting constitutes your acceptance of the revised Agreement. If you do not agree to the revised terms, you must cease using the Licensed Content and Services.<br/>
&nbsp;&nbsp;2.7. This License will terminate immediately if the User defaults or breaches any term of this License.<br/>

<p><strong>III. DELIVERY & ACCESS</strong></p>
3. Each Product package includes one Unique Code card.<br/>
4. Unique Codes do not expire.<br/>
5. In the event of loss, theft, or damage of a Unique Code, Para Bellum may, upon proof of purchase and at its sole discretion, issue a replacement code.<br/>
6. Codes are personal to you and must not be resold, shared, traded, or transferred.<br/>

<p><strong>IV. PROHIBITED USES</strong></p>
7. You must not, and must not permit others to:
&nbsp;&nbsp;7.1. copy, reproduce, modify, adapt, or create derivative works from the Licensed Content or Services;<br/>
&nbsp;&nbsp;7.2. distribute, sublicense, lease, rent, sell, or otherwise commercially exploit the Licensed Content, Services, or Unique Codes;<br/>
&nbsp;&nbsp;7.3. reverse engineer, decompile, or attempt to derive source code from the Services or Licensed Content;<br/>
&nbsp;&nbsp;7.4. bypass or attempt to circumvent any security or authentication mechanisms;<br/>
&nbsp;&nbsp;7.5. cheat, exploit, or manipulate tournaments, rankings, or reward programs;<br/>
&nbsp;&nbsp;7.6. use the Licensed Content or Services in violation of applicable laws.<br/>

<p><strong>V. COMMERCIAL MODEL & FEES</strong></p>
8. The total purchase price you pay for each Product covers both the physical model and the license to access the Rules and related Services. For internal and invoicing purposes, this total price includes a portion allocated to the physical Product and a portion allocated to the License Fee for the Licensed Content and Services. The total price will be displayed to you at the time of purchase. Any allocation of value between components is shown on invoices issued by Para Bellum for accounting and regulatory purposes only. If you return the physical Product in accordance with Para Bellum&rsquo;s return policy, the corresponding license will also be cancelled and refunded.<br/>

<p><strong>VI. INTELLECTUAL PROPERTY RIGHTS</strong></p>
9. All intellectual property rights in the Licensed Content, Services, App, tournament structures, trademarks, logos, and related materials remain the exclusive property of Para Bellum.<br/>
10. You acknowledge that the Licensed Content is protected by copyright laws, treaties, and international conventions.<br/>
11. Any unauthorised use or infringement shall entitle Para Bellum to seek injunctive relief, damages, and other remedies under applicable law.<br/>

<p><strong>VII. CONSUMER PROTECTION & STATUTORY RIGHTS</strong></p>
12. This Agreement is subject to the laws of Cyprus and applicable European Union consumer protection legislation.<br/>
13. Nothing in this Agreement limits or excludes your statutory consumer rights, including rights to withdrawal, returns, and refunds under applicable EU law.<br/>
14. If you are a consumer residing outside the EU, local mandatory consumer protection laws may also apply.<br/>

<p><strong>VIII. CONFIDENTIALITY</strong></p>
15. You acknowledge that the Licensed Content, the Rules, and related materials contain proprietary and confidential information belonging to Para Bellum Games Ltd and its licensors ("Confidential Information"). Confidential Information includes, without limitation:<br/>
&nbsp;&nbsp;15.1. the Rules and Licensed Content;<br/>
&nbsp;&nbsp;15.2. any information provided to you through Para Bellum&rsquo;s website, account, or Services which is identified as confidential or should reasonably be understood to be confidential; and<br/>
&nbsp;&nbsp;15.3. any notes, extracts, or derivative materials you create from the Rules or Licensed Content.<br/>
16. Confidential Information does not include information which you can clearly demonstrate by written evidence:<br/>
&nbsp;&nbsp;16.1. was lawfully known to you before disclosure;<br/>
&nbsp;&nbsp;16.2. is or becomes publicly available through no fault of yours;<br/>
&nbsp;&nbsp;16.3. is independently developed by you without reference to the Confidential Information; or<br/>
&nbsp;&nbsp;16.4. is lawfully received from a third party without breach of a confidentiality obligation.<br/>
17. You agree not to disclose Confidential Information to any third party and to treat it with the same degree of care you use to protect your own confidential information, but in no event less than a reasonable degree of care.<br/>
18. Except as expressly permitted under this Agreement, you must not copy, reproduce, or use Confidential Information for any purpose other than personal, non-commercial gameplay.<br/>
19. You may disclose Confidential Information if required by applicable law, regulation, or a valid court order, provided that you give Para Bellum prompt written notice (where legally permissible) and limit disclosure to the minimum necessary.<br/>
20. Your confidentiality obligations under this Agreement shall survive termination of the License.<br/>

<p><strong>IX. UPDATES, MODIFICATIONS & SUPPORT</strong></p>
21. Para Bellum may update the Licensed Content periodically to rebalance gameplay, correct errors, or improve functionality.<br/>
22. Updates are included within the License term.<br/>
23. Para Bellum shall provide reasonable technical support relating to code activation, account access, and downloading updates. Para Bellum does not guarantee uninterrupted access or error-free performance.<br/>

<p><strong>X. WARRANTIES & DISCLAIMERS</strong></p>
24. Para Bellum warrants that it has the right to grant this License and that the Licensed Content, when properly accessed, shall perform substantially as described.<br/>
25. Except as expressly provided herein, the Licensed Content and Services are provided "AS IS" and "AS AVAILABLE," without warranties of any kind, whether express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, or non-infringement.<br/>
26.Para Bellum does not warrant that the Licensed Content will be uninterrupted, error-free, secure, or free from harmful components.<br/>

<p><strong>XI. LIMITATION OF LIABILITY</strong></p>
27. To the maximum extent permitted by law, Para Bellum shall not be liable for:<br/>
&nbsp;&nbsp;27.1. indirect, incidental, special, punitive, or consequential damages;<br/>
&nbsp;&nbsp;27.2. loss of data, profits, goodwill, or business opportunities;<br/>
&nbsp;&nbsp;27.3. damages resulting from unauthorised access or use of the Licensed Content, Services, or Unique Codes.<br/>
28. Nothing in this Agreement excludes or limits liability for:<br/>
&nbsp;&nbsp;28.1. death or personal injury caused by negligence;<br/>
&nbsp;&nbsp;28.2. fraud or fraudulent misrepresentation; or<br/>
&nbsp;&nbsp;28.3. any other liability that cannot be excluded under applicable law.<br/>
29. In no event shall Para Bellum&rsquo;s total liability exceed the License Fee actually paid by you.<br/>

<p><strong>XII. DATA PROTECTION & PRIVACY</strong></p>
30. Para Bellum shall process personal data in accordance with the General Data Protection Regulation (EU) 2016/679 ("GDPR") and applicable Cyprus law.<br/>
31. By registering your Unique Code, you consent to the collection and processing of your personal data for:<br/>
&nbsp;&nbsp;31.1. account creation and management;<br/>
&nbsp;&nbsp;31.2. provision of Licensed Content and Services;<br/>
&nbsp;&nbsp;31.3. verification of tournament eligibility; and<br/>
&nbsp;&nbsp;31.4. communications relating to updates and support.<br/>
32. Further details are provided in Para Bellum&rsquo;s Privacy Policy, available on its website.<br/>

<p><strong>XIII. TERMINATION</strong></p>
33. Para Bellum may suspend or terminate this Agreement immediately upon notice if you:<br/>
&nbsp;&nbsp;33.1. materially breach any provision of this Agreement;<br/>
&nbsp;&nbsp;33.2. engage in prohibited use; or<br/>
&nbsp;&nbsp;33.3. use the Licensed Content in a manner inconsistent with applicable law.<br/>
34. Upon termination:<br/>
&nbsp;&nbsp;34.1. your License shall immediately cease;<br/>
&nbsp;&nbsp;34.2. you must stop all use of the Licensed Content and Services; and<br/>
&nbsp;&nbsp;34.3. Para Bellum may disable your access.<br/>
35. Termination does not affect accrued rights or remedies of Para Bellum.<br/>

<p><strong>XIV. FORCE MAJEURE</strong></p>
36. Para Bellum shall not be liable for any failure or delay in performance caused by events beyond its reasonable control, including but not limited to acts of God, natural disasters, pandemics, epidemics, government actions or restrictions, labour disputes, power failures, internet or telecommunications outages, or cyber-attacks ("Force Majeure Events").<br/>
37. If a Force Majeure Event occurs, Para Bellum will take reasonable steps to mitigate its effects and will notify Users of the event and any impact on the Services by email and/or by posting a notice on its website or app. Such notice shall be deemed sufficient under this Agreement.<br/>
38. The obligations of Para Bellum shall be suspended for the duration of the Force Majeure Event, provided that performance resumes as soon as reasonably practicable once the event ends.<br/>

<p><strong>XV. NOTICES</strong></p>
39. All notices and communications under this Agreement shall be made in writing.<br/>
&nbsp;&nbsp;39.1. From Para Bellum to You. Para Bellum may provide notices to you by:<br/>
&nbsp;&nbsp;&nbsp;&nbsp;39.1.1. email sent to the address you provided when registering your Unique Code; and/or<br/>
&nbsp;&nbsp;39.2. posting a notice on its website or within your account dashboard.<br/>
&nbsp;&nbsp;39.3. Such notices shall be deemed delivered upon successful transmission of the email or upon posting on the website, whichever occurs first.<br/>
&nbsp;&nbsp;39.4. From You to Para Bellum. You may provide notices to Para Bellum by email to [insert official contact email] or by post to Para Bellum&rsquo;s registered office address as published on its website. Notices by email are deemed delivered upon successful transmission, and by post five (5) business days after posting.<br/>
&nbsp;&nbsp;39.5. You agree that Para Bellum will issue and deliver your final purchase invoice electronically only to the email address you provide at the time of purchase or registration. No paper invoice will be sent. It is your responsibility to ensure that a valid and accessible email address is provided and maintained.<br/>

<p><strong>XVI. GOVERNING LAW & JURISDICTION</strong></p>
40. This Agreement shall be governed by and construed in accordance with the laws of the Republic of Cyprus.<br/>
41. The courts of Cyprus shall have exclusive jurisdiction to settle any disputes arising under or in connection with this Agreement.<br/>

<p><strong>XVII. GENERAL PROVISIONS</strong></p>
42. Entire Agreement. This Agreement constitutes the entire agreement between you and Para Bellum regarding the Licensed Content and supersedes any prior agreements.<br/>
43. If any provision is found invalid or unenforceable, the remaining provisions shall remain valid and enforceable.<br/>
44. No Waiver. Failure to enforce any provision shall not constitute a waiver of any rights.<br/>
45. Para Bellum may assign or transfer its rights and obligations under this Agreement. You may not assign your rights without Para Bellum&rsquo;s prior written consent.<br/>
46. Provisions relating to intellectual property, prohibited uses, limitation of liability, and governing law shall survive termination.<br/>

<p><strong>ACKNOWLEDGEMENT</strong></p>
<p>By purchasing a Para Bellum Product and accessing Licensed Content or Services, you confirm that you have read, understood, and agree to be bound by this End User License Agreement.</p>
<p>
PARA BELLUM GAMES LTD<br/>
Registered in Cyprus, Reg. No. &Eta;&Epsilon;297366<br/>
Website: <a href="http://www.para-bellum.com">www.para-bellum.com</a>
</p>
`;

function TariffyDialog() {
	const { tariffyOpen } = useSelector((state) => state.utils);
	const { currentUser, onCurrentUserChange } = useContext(UserCtx);
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const initialInputsState = {
		code: "",
		codeStatus: null,
	}
	const [inputs, setInputs] = useState(initialInputsState);
	const [eulaAccepted, setEulaAccepted] = useState(false);

	if (!tariffyOpen) return;

	async function handleUnlock() {
		let error = false;

		if (inputs.code?.length !== 5) {
			error = true;
			setInputs((prevInputs) => ({
				...prevInputs,
				codeStatus: "Activation code must be 5 characters long.",
			}));
		}

		if (!error) {
			try {
				// const response = await axios.post("http://192.168.1.10:3000/api/v1/users/tariffy", {username: currentUser.username, code: inputs.code});
				const response = await axios.post("https://living.para-bellum.com/api/v1/users/tariffy", {username: currentUser.username, code: inputs.code});
				if (response.status === 200) {
					enqueueSnackbar("Account unlocked.", { variant: "success" });
					dispatch(closeTariffy());
					onCurrentUserChange({...currentUser, list_building: "unlocked"})
				}
			} catch ({response}) {
				const message = response.data?.message || "Unknown error."
				enqueueSnackbar(`Failed to unlock account: ${message}`, { variant: "error" });
			}
		}
	}

	function handleCodeChange(code) {
		setInputs(prevInputs => ({
			...prevInputs,
			code: code.target.value,
			codeStatus: null,
		}));
	}

	function handleCancel() {
		setInputs(initialInputsState);
		setEulaAccepted(false);
		dispatch(closeTariffy());
	}

	function handleAcceptEula() {
		setEulaAccepted(true);
	}

	const unlockAction = {
		id: "Unlock",
		label: "Unlock",
		handler: handleUnlock,
	};

	const cancelAction = {
		id: "Cancel",
		icon: CloseIcon,
		handler: handleCancel,
	};

	const actions = [
		cancelAction,
		unlockAction,
	];

	const eulaActions = [
		{
			id: "Cancel",
			icon: CloseIcon,
			handler: handleCancel,
		},
	];

	return eulaAccepted ? (
		<FrameDialog open onClose={handleCancel} responsive actions={actions}>
			<FrameHeader title="Unlock Account" />
			<FrameDialogContent>
				<TextField
					label="Activation code"
					size="small"
					required
					fullWidth
					value={inputs.code}
					onChange={handleCodeChange}
					helperText={inputs.codeStatus}
					error={!!inputs.codeStatus}
				/>
			</FrameDialogContent>
		</FrameDialog>
	) : (
		<FrameDialog open onClose={handleCancel} responsive actions={eulaActions}>
			<FrameHeader title="EULA" />
			<FrameDialogContent>
				<Typography dangerouslySetInnerHTML={{ __html: eulaText }} />
				<Button variant="contained" size="large" onClick={handleAcceptEula}>I have read and I agree</Button>
			</FrameDialogContent>
		</FrameDialog>
	);
}


export default TariffyDialog;